import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { BackButton, NavBar } from '../../components/layout/NavBar'
import { Services } from '@/services/services'
import { useNavigate, useParams } from 'react-router-dom'

import './FailureMap.css'
import { CurrentSession } from '@/services/repository/session'
import { MainLayout, MainPageLayout } from '@/components/layout/MainLayout'
import { useLogin } from '@/context/login'
import { MachineFailureTypes } from '@/services/repository/machines'
import { formatDate } from '@/common/time'
import { MachinePath } from './machine/Common'
import { Machine } from '@/services/model/machine'
import { Translates } from '@/services/repository/i18n'
import { FailuresMapComponent } from '@/components/Map/FailuresMap'
import { Spinner } from '@/components/spinner'

export const CommunalMachineFailuresMap = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const mid = useParams().mid
  const [translates, setTranslates] = useState<Translates>()
  // const [machine, setMachine] = useState<Machine>()

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  // useEffect(() => {
  //   setMachine(undefined)
  //   fetch(`/api/communal/machines/byid/${mid}`).then((response) => {
  //     return response.json()
  //   }).then((data) => {
  //     setMachine(data)
  //   })
  // }, [mid])
  //|| machine === undefined || failures === undefined

  if (!translates) {
    return <Spinner />
  }

  return <MainPageLayout pageName='communal-machine-failure-map' services={services} translates={translates} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <p className='description'>
      {translates.for('page.communal-machine-failure-map.description')}
    </p>
    <div className='default-map-container'>
      <FailuresMapComponent fetchUrl='/api/communal/failures/map' services={services} session={session} />
    </div>
  </MainPageLayout>
}
